// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"556":"91cb527f","844":"f5d7f600"}[chunkId] + ".css";
};